<template>
  <div id="SocialBar" :class="classColor">
    <div class="d-flex align-items-center" :class="mod ? 'container' : 'container-fluid'">
      <a href="https://www.facebook.com/virtextelecom" target="_blank" class="circle-social">
        <i class="socicon-facebook"></i>
      </a>
      <a href="https://www.instagram.com/virtextelecom" target="_blank" class="circle-social">
        <i class="socicon-instagram"></i>
      </a>
      <a href="https://www.twitter.com/virtextelecom" target="_blank" class="circle-social">
        <i class="socicon-twitter"></i>
      </a>
      <a href="https://www.linkedin.com/company/virtextelecom" target="_blank" class="circle-social">
        <i class="socicon-linkedin"></i>
      </a>
      <a href="https://www.youtube.com/channel/UCVJ_HBkbciCg9yjVN2ofKsw" target="_blank" class="circle-social">
        <i class="socicon-youtube"></i>
      </a>
      <div class="circle-social" v-if="whatsapp !== '-'">
        <i class="socicon-whatsapp"></i>
      </div>
      <a :href="'https://telegram.me/' + telegram" target="_blank" class="circle-social" v-if="telegram !== '-'">
        <i class="socicon-telegram"></i>
      </a>
      <div class="fill-empty d-flex justify-content-center" v-if="!mod">
        <h6 class="mb-0 bold">Todos os direitos reservados VirteX LTDA.</h6>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'social-bar',
    props: {
      mod: { default: false, type: Boolean },
      whatsapp: { type: String, default: "-" },
      telegram: { type: String, default: "-" },
      classColor: { type: String, default: "" }
    }
  }
</script>

<style scoped lang="scss">
  $circle-tamanho: 42px;
  $barra-tamanho: 60px;
  $barra-padding: 8px;

  $primary: #cc0000;

  #SocialBar {
    overflow: hidden;
    display: flex;
    width: 100%;
    height: $barra-tamanho;
    align-items: center;
    padding: 0 $barra-padding 0 $barra-padding;
    background-color: #fff;
  }

  .circle-social {
    transition: 250ms;
    cursor: pointer;
    border-radius: 50%;
    width: $circle-tamanho;
    height: $circle-tamanho;
    max-width: $circle-tamanho;
    max-height: $circle-tamanho;
    min-width: $circle-tamanho;
    min-height: $circle-tamanho;
    display: flex;
    background-color: $primary;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    &:hover { background-color: darken($primary, 8%) }
    i {
      color: #fff;
      font-size: 15pt;
      margin-top: 4px;
    }
  }
</style>
